(function() { module.exports = window["wp"]["richText"]; }());